<template>
    <div class="text-center py-10">
        <i class="fa-solid fa-spinner fa-spin-pulse fa-7x"></i>
        <h3>Estamos preparando tu contenido</h3>
    </div>
</template>

<script>
export default {

}
</script>
